import { z } from "zod";
/**
 * Personal Home navigation widgets carry no domain content. My SOLVEs/My VSMs
 * read through data connections. Quick Access receives the current authorized
 * module catalogue from the shell host and stores only opaque module ids.
 */
export const MySolvesParamsSchema = z.object({}).strict();
export const defaultMySolvesParams = {};
export const MyVsmsParamsSchema = z.object({}).strict();
export const defaultMyVsmsParams = {};
export const QuickAccessParamsSchema = z
    .object({
    mode: z.enum(["all", "selected"]).optional(),
    selectedModuleIds: z
        .array(z.string().trim().min(1).max(80))
        .max(24)
        .optional(),
})
    .strict()
    .superRefine((value, context) => {
    if (value.mode === "selected" &&
        (value.selectedModuleIds?.length ?? 0) === 0) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["selectedModuleIds"],
            message: "Select at least one app.",
        });
    }
    if (value.selectedModuleIds !== undefined &&
        new Set(value.selectedModuleIds).size !== value.selectedModuleIds.length) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["selectedModuleIds"],
            message: "Each app can be selected only once.",
        });
    }
});
export const defaultQuickAccessParams = {
    mode: "all",
    selectedModuleIds: [],
};
//# sourceMappingURL=homeNavigation.js.map